import { Route } from 'react-router-dom';
import './App.css';
import { Routes, } from 'react-router-dom';
import Home from './pages/Home';
import Products from './pages/Products'
import Product from './pages/Product'
import Cart from './pages/Cart'



function App() {
  return (
    <div>
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='products' element={<Products />} />
        <Route path='product/:id' element={<Product />} />
        <Route path='cart' element={<Cart />} />
      </Routes>
    </div>
  );
}

export default App;
